interface ClientAppConfig {
  emailTemplate: string;
  imageHost: (() => string) | null;
  passwordResetLinkBuilder: (route: string) => string;
  isCarrier: boolean;
}

/** Identifies which frontend app should receive password-reset (and related) links in email. */
export class ClientApp {
  constructor(private readonly config: ClientAppConfig) {}

  getEmailTemplate(): string {
    return this.config.emailTemplate;
  }

  getImageHost(): string | null {
    return this.config.imageHost ? this.config.imageHost() : null;
  }

  buildPasswordResetLink(route: string): string {
    return this.config.passwordResetLinkBuilder(route);
  }

  isCarrier(): boolean {
    return this.config.isCarrier;
  }
}
